// extracted by mini-css-extract-plugin
export default {"formHeading":"SK-z","form":"TK-z","submitBtn":"UK-z","disabled":"VK-z","input":"WK-z","error":"XK-z","submitMsg":"YK-z","signIn":"ZK-z"};